exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.description_description_TJxeu {\r\n    max-height: calc(520px - 1rem - 0.125rem - 2px);\r\n    overflow: auto;\r\n    white-space: pre-line;\r\n    overflow-wrap: break-word;\r\n    line-height: 1.5em;\r\n    padding: 0.5rem;\r\n    margin: 5px 0 8px 0;\r\n    border: 1px solid var(--badge-border);\r\n    background-color: var(--badge-background);\r\n    border-radius: 0.5rem;\r\n}\r\n\r\n.description_description_TJxeu a {\r\n    font-weight: bold;\r\n    text-decoration: none;\r\n}\r\n\r\n.description_header_3Bv2V {\r\n    font-weight: bold;\r\n    font-size: 1em;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.description_divider_NGZle {\r\n    margin-top: 8px;\r\n}\r\n\r\n.description_project-link_2xt5_ {\r\n    margin-bottom: 2px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"description": "description_description_TJxeu",
	"header": "description_header_3Bv2V",
	"divider": "description_divider_NGZle",
	"project-link": "description_project-link_2xt5_",
	"projectLink": "description_project-link_2xt5_"
};